import {BaseProps} from "../../../infrastructure/models/props/base-props";

import React from 'react';

export class TableCellProps extends BaseProps {
  className: String;
  colSpan: Number;
}

export const TableCell = ({className, colSpan, children, style}: TableCellProps) => {
  return (
    <td className={className} colSpan={colSpan} style={style}>
      {children}
    </td>
  )
}
